export const forums = {
  forumsSearchInputPlaceholder: 'Paieška',
  forumsFollowDiscussionButtonTitle: 'Sekti',
  forumsFollowingDiscussButtonTitle: 'Sekama',
  forumDiscussionInfoNoReplyText: 'Atsakymų dar nėra',
  forumsDiscussionDetailsStartButtonTitle: 'Pradėti diskusiją',
  forumDetailsCreatedByText: 'autorius',
  forumsDiscussionDetailsUsersCurtainCopyOptionTitle: 'Kopijuoti nuorodą',
  forumsDiscussionDetailsUsersCurtainFlagOptionTitle: 'Pažymėti turinį',
  forumsReportedCurtainContent: 'Turinys pažymėtas',
  forumsDiscussionDetailsUserCurtainCopiedAlertText: 'Nuoroda nukopijuota!',
  forumsDiscussionDetailsOwnersCurtainPinOptionTitle: 'Prisegti diskusiją',
  forumsDiscussionDetailsOwnersCurtainUnpinOptionTitle: 'Atsegti diskusiją',
  forumsDiscussionDetailsOwnersCurtainEditOptionTitle: 'Redaguoti diskusiją',
  forumsDiscussionDetailsOwnersCurtainDeleteOptionTitle: 'Ištrinti diskusiją',
  forumsDiscussionDetailspPopupDeleteTitle: 'Ištrinti',
  forumsDiscussionDetailspPopupDeleteText: 'Ištrinti šią diskusiją?',
  forumsDiscussionDetailspPopupCancelButtonTitle: 'Atšaukti',
  forumsDiscussionDetailspPopupConfirmButtonTitle: 'Patvirtinti',
  forumsDiscussionDetailsDeleledAlertText: 'Diskusija ištrinta!',
  forumsNewDiscussionTitle: 'Nauja diskusija',
  forumsNewDiscussionTitlePlaceholder: 'Pavadinimas...',
  forumsNewDiscussionBodyPlaceholderText: 'Rašykite tekstą čia...',
  forumsNewDiscussionPublishButtonTitle: 'Paskelbti',
  forumsNewDiscussionLocationCurtainTitle: 'Vieta',
  forumsNewDiscussionLocationCurtainInputPlaceholder: 'Vietos pavadinimas',
  forumsNewDiscussionEditLocationCurtainText: 'Redaguoti vietą',
  forumsNewDiscussionDeleteLocationCurtainText: 'Ištrinti vietą',
  forumsNewDiscussionCreatePollTitle: 'Sukurti apklausą',
  forumsNewDiscussionTitleInputPlaceholder: 'Pavadinimas',
  forumsNewDiscussionOptionInputPlaceholder: 'Pasirinkimas',
  forumsNewDiscussionAddButtonTitle: 'Pridėti pasirinkimą',
  forumsNewDiscussionCreateButtonTitle: 'Sukurti',
  forumsNewDiscussionPollTitleBlankAlertText: 'Pavadinimas negali būti tuščias!',
  forumsNewDiscussionPollOptionBlankAlertText: 'Pasirinkimas negali būti tuščias!',
  forumsNewDiscussionPollLongTitleAlertText: 'Pavadinimas turi būti ne ilgesnis kaip 140 simbolių',
  forumsNewDiscussionPollLongOptionAlertText: 'Pasirinkimas turi būti ne ilgesnis kaip 50 simboliai',
  forumsNewDiscussionEditPollIconText: 'Redaguoti apklausą',
  forumsNewDiscussionRemovePollIconText: 'Pašalinti apklausą',
  forumsDiscardDraftPopupTitle: 'Juodraštis',
  forumsDiscardDraftPopupText: 'Atmesti šį juodraštį?',
  forumsDiscardDraftPopupCancelButtonTitle: 'Atšaukti',
  forumsDiscardDraftPopupConfirmButtonTitle: 'Patvirtinti',
  forumsDiscussionDetailsPostBodyReplyIconTitle: 'Atsakyti',
  forumsDiscussionDetailsNoCommentsText: 'Komentarų dar nėra\nGalite būti pirmas(-a), kuris palieka komentarą',
  forumsDiscussionDetailsReplyInputPlaceholder: 'Atsakyti',
  forumsDiscussionDetailsPostShareCurtainOptionTitle: 'Kopijuoti nuorodą',
  forumsDiscussionDetailsPostShareCopiedAlertText: 'Nuoroda nukopijuota!',
  forumsDiscussionDetailsPostUsersCurtainFlagOptionTitle: 'Pažymėti turinį',
  forumsDiscussionDetailsPostCurtainReportedText: 'Turinys pažymėtas',
  forumsDiscussionDetailsCommentReplyIconTitle: 'Atsakyti',
  forumsEditDiscussionTitle: 'Redaguoti diskusiją',
  forumsEditDiscussionSaveButtonTitle: 'Išsaugoti',
  forumsEditedDiscussionSavedAlertText: 'Diskusija išsaugota!',
  forumsDiscussionDetailsOwnersCommentCurtainEditOptionTitle: 'Redaguoti atsakymą',
  forumsDiscussionDetailsOwnersCommentCurtainDeleteOptionTitle: 'Ištrinti atsakymą',
  forumsDiscussionDetailsEditedCommSavedAlertText: 'Komentaras išsaugotas!',
  forumsDiscussionDetailsEditedCommDeletedAlertText: 'Komentaras ištrintas!',
  forumsAlertSomethinWrong: 'Įvyko klaida!',
  forumsMaxMbSize: 'Vienu metu galite įkelti ne daugiau kaip {size} MB',
  forumsMaxAttachments: 'Viršijote leistiną prisegtukų skaičių. Maksimalus prisegtukų skaičius: {max}',
  forumsDiscussionDetailsDeleteCommentPopupTitle: 'Ištrinti',
  forumsDiscussionDetailsDeleteCommentPopupText: 'Ištrinti šį komentarą?',
  forumsDiscussionDetailsDeleteCommentPopupCancelButtonTitle: 'Atšaukti',
  forumsDiscussionDetailsDeleteCommentPopupConfirmlButtonTitle: 'Patvirtinti',
  forumsDiscussionDetailsUsersCommentCurtainFlagOptionTitle: 'Pažymėti turinį',
  forumsDiscussionDetailsCommentReportedCurtainText: 'Turinys pažymėtas',
  forumDiscussionInfoLastReplyText: 'Paskutinis atsakymas',
  forumsDiscussionAt: 'prie',
  forumsDiscussionDetailsFlagCurtainTitle: 'Pažymėti',
  forumsDiscussionDetailsFlaggedReportedCurtainContent: 'Turinys pažymėtas',
  forumsPollInfoVotesText: 'balsai',
  forumsPollInfoEditVoteText: 'Redaguoti balsą',
  forumsPollFinishPollText: 'Baigti apklausą',
  forumsPollFinishedPollText: 'Baigta',
  forumsPollInProgresslText: 'Vyksta',
  forumsPollCurtainTitle: 'Baigti apklausą',
  forumsPollCurtainText: 'Po apklausos pabaigos vartotojai nebegalės balsuoti.',
  forumsFinishPollCurtainCancelButtonTitle: 'Atšaukti',
  forumsFinishPollCurtainConfirmlButtonTitle: 'Patvirtinti',
  forumsPollInfoPollVotesCurtainTitle: 'Apklausos balsai'
}
